import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { Chip } from "@material-ui/core";
import { removeDuplicates, sortArray } from "../../../utils/helper";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset"
    }
  }
});

/**
 * Used for Rendering Collapsible row in Table
 * @param {*} props
 * @returns Row with Child Table
 */
function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label={"expand row"}
            size={"small"}
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component={"th"} scope={"row"}>
          {row.UserName}
        </TableCell>
        <TableCell align={"right"}>{row.OfficePhone}</TableCell>
        <TableCell align={"right"}>{row.CellPhone}</TableCell>
        <TableCell align={"right"}>{row.Email}</TableCell>
        <TableCell align={"right"}>{}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout={"auto"} unmountOnExit>
            <Box margin={1}>
              <p>{"Request Permissions"}</p>
              {row.RequestTypes == null
                ? "-"
                : sortArray(removeDuplicates(row.RequestTypes.split(",")))?.map(
                    (obj, index) => (
                      <Chip
                        key={"chip" + index + "c"}
                        label={obj}
                        style={{
                          margin: 1,
                          fontSize: "0.7rem",
                          height: "1.8rem"
                        }}
                      />
                    )
                  )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired
  }).isRequired
};

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

/**
 * Used for Generating Contact list view for Tenant for Mobile View
 * @param {*} data
 * @param {*} col
 * @returns TenantViewContactTableMobileView
 */
export default function TenantViewContactTableMobileView(data) {
  const classes = useStyles();
  return (
    <TableContainer component={Paper}>
      <Table
        className={classes.table}
        size={"small"}
        aria-label={"collapsible table"}
      >
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell align={"left"}>{"Tenant Name"}</TableCell>
            <TableCell align={"left"}>{"Work Phone"}</TableCell>
            <TableCell align={"left"}>{"Cell Phone"}</TableCell>
            <TableCell align={"left"}>{"Email"}</TableCell>
            <TableCell style={{ textAlign: "center" }}>{"Action"}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.data?.length > 0 ? (
            (data.data || []).map(row => (
              <Row key={row.TenantUserId} row={row} />
            ))
          ) : (
            <></>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
